import React from 'react'
import Pages from './Routes'
import { BrowserRouter } from 'react-router-dom'
import { AdminCrudContextProvider } from './ContextManagement/ContextManager';

function App() {
	return (
		<BrowserRouter basename="/admin/">
			<AdminCrudContextProvider>
				<Pages />
			</AdminCrudContextProvider>
		</BrowserRouter>
	);
}

export default App;
